import Colors from 'constants/Colors';

export default {
  buttonContainer: {
    display: 'flex',
    justifyContent: 'right',
    marginTop: 32,
  },
  activeStatus: {
    textAlign: 'center',
    color: Colors.greenHotelIntegratedText,
    backgroundColor: Colors.greenHotelIntegratedBg,
    borderRadius: 16,
    border: 0,
    width: 110,
    height: 22,
  },
  blockedStatus: {
    textAlign: 'center',
    color: Colors.redDesactivedText,
    backgroundColor: Colors.redDesactivedBg,
    borderRadius: 16,
    border: 0,
    width: 110,
    height: 22,
  },
  blockedText: {
    color: Colors.redDesactivedText,
  },
  pendingStatus: {
    textAlign: 'center',
    color: Colors.yellowHotelNoIntegratedText,
    backgroundColor: Colors.yellowHotelNoIntegratedBg,
    borderRadius: 16,
    border: 0,
    width: 110,
    height: 22,
  },
  topButtonContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end', // alineación a la derecha
    paddingRight: '20px',
  },
};
